import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'brover-thanks-page',
    templateUrl: './thanks-page.component.html',
    styleUrls: ['./thanks-page.component.sass'],
    standalone: false
})
export class ThanksPageComponent implements OnInit, OnDestroy {
  private orderId;
  private timer;

  public timeOut = 5;

  public lottieConfig: Object;
  private anim: any;

  constructor(private router: Router, private active: ActivatedRoute) {
    this.lottieConfig = {
      path: 'assets/lottie/animation-w1200-h1200.json',
      autoplay: true,
      loop: true
    };
  }

  handleAnimation(anim: any) {
    this.anim = anim;
  }


  ngOnInit() {
    this.active.queryParams.subscribe(x => {
      this.orderId = x.orderId;
    });

    this.timer = setInterval(() => {
      if (this.timeOut === 0) {
        this.redirectToOrder();
      } else {
        this.timeOut -= 1;
      }
    }, 1000);
  }

  redirectToOrder() {
    clearInterval(this.timer);
    this.router.navigate(['/', 'dashboard', 'order-history', this.orderId, ]);
  }

  ngOnDestroy() {
    clearInterval(this.timer);
  }
}
